


























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SitePerm, siteAdminPermApis, InvalidParam } from '../../api';

@Component
export default class PermEditDialog extends Vue {
  readonly rules = {
    name: { required: true, message: '请输入权限标识' },
    title: { required: true, message: '请输入权限名称' }
  };

  @Prop() siteId!: number;
  dialogVisible = false;
  perm: SitePerm | null = null;
  resolve: ((perm: SitePerm) => void) | null = null;
  errors = {};

  show(groupId: number | null, perm: SitePerm | null) {
    this.errors = {};
    if (perm) {
      this.perm = JSON.parse(JSON.stringify(perm));
    } else {
      this.perm = {} as SitePerm;
      if (groupId) {
        this.perm.group_id = groupId;
      }
    }
    this.dialogVisible = true;
    return new Promise<SitePerm>(resolve => (this.resolve = resolve));
  }

  async save() {
    try {
      if (this.perm) {
        const perm = await siteAdminPermApis.savePerm(this.siteId, this.perm);
        if (this.resolve) {
          this.resolve(perm);
        }
      }
      this.dialogVisible = false;
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error(e.message);
      }
    }
  }

  onClosed() {
    this.perm = null;
    this.resolve = null;
  }
}
